// ==========================
// CONFIG
// ==========================

(function () {

  const hsData = document.getElementById("hotspots-product-data");

const HOTSPOTS_ENABLED =
  hsData?.dataset?.hotspotsEnabled === "true";

  if (!HOTSPOTS_ENABLED) return false;

let isAutoPlaying = false;
let autoTimer = null;
let isSwitchingImage = false;
let currentIndex = 0;
let timeline = [];

let currentImageIndex = 0;
let typingTimer = null;
let activeImageConfig = {};
let isScrolling = false;
let scrollTimeout = null;

let currentKey = "";
let currentStep = 0;
let activeContainer = null;
let isUserInteracted = false;

let hasAutoPlayed = false;
let isInViewport = false;
const productId = document.querySelector('[data-product-id]')?.dataset?.productId;
const AUTO_PLAY_KEY = `hs_auto_played_${productId}`;


const HOTSPOT_IMAGE_MAP = {
  border: 0,
  body: 0,
  pallu: 1,
  silkmark: 1
};

const HOTSPOT_PRIORITY = {
  body: 1,
  border: 2,
  pallu: 3,
  silkmark: 4
};

const TEMPLATES = {
  flat: [
    {
      body: { x: 50, y: 50, zoom: 1.6 },
      border: { x: 50, y: 82, zoom: 1.6 }
    },
    {
      pallu: { x: 75, y: 55, zoom: 1.6 },
      silkmark: { x: 30, y: 80, zoom: 1.0 }
    }
  ],
   draped: [
    {
      // Image 1 (full draped saree)
      body: { x: 48, y: 55, zoom: 1.6 },
      border: { x: 82, y: 70, zoom: 1.6 }
    },
    {
      // Image 2 (pallu focus)
      pallu: { x: 50, y: 55, zoom: 1.6 },
      silkmark: { x: 78, y: 85, zoom: 1.0 }
    }
  ]
};

const hsContentData = document.getElementById("hotspots-product-data");

let CONTENT = {};

try {
  CONTENT = JSON.parse(hsContentData.dataset.hotspotsContent || "{}");
} catch (e) {
  console.warn("Invalid hotspots content JSON", e);
}

// ==========================
// INIT
// ==========================

const hotspotsImageType = hsContentData?.dataset?.hotspotsImageType?.trim().toLowerCase() || "";
const config = TEMPLATES[hotspotsImageType];
const containers = document.querySelectorAll(".hotspots");

// ==========================
// HOTSPOTS RENDER
// ==========================

containers.forEach((container, index) => {
  container.innerHTML = "";

  const imageConfig = config[index] || {};

  Object.keys(imageConfig).forEach((key) => {
    const hs = imageConfig[key];

    // 🔥 skip silkmark dot
  if (key === "silkmark") return;

    const dot = document.createElement("div");
    dot.className = "hotspot";

    dot.style.left = hs.x + "%";
    dot.style.top = hs.y + "%";
    dot.style.opacity = "0";
    dot.style.pointerEvents = "none";

    dot.addEventListener("click", (e) => {
      stopAutoPlay();
      e.stopPropagation();

      document.querySelectorAll(".hotspot").forEach(h => {
        h.style.opacity = "0.3";
      });

      e.currentTarget.style.opacity = "1";

      startStory(key, container, imageConfig);
    });

    container.appendChild(dot);
  });
});

// ==========================
// STORY
// ==========================

function startStory(key, container, imageConfig) {
  currentKey = key;
  currentStep = 0;
  activeContainer = container;
  activeImageConfig = imageConfig;

  showStep();
}

function showStep() {

  const text = CONTENT[currentKey].steps[currentStep] || "";

// 🔥 get typing duration
const typingDuration = typeText(
  document.getElementById("hs-text"),
  text,
  18
);

// store globally
window.currentTypingDuration = typingDuration;

  const hs = activeImageConfig[currentKey];
  if (!hs) return;

  const img = activeContainer
    ?.closest(".product-media-container")
    ?.querySelector("img");

if (img) {
  applyZoom(img, hs);
}

  const storyCard = document.getElementById("story-card");

  if (hs.y > 30) {
    storyCard.style.top = "12px";
    storyCard.style.bottom = "auto";
  } else {
    storyCard.style.bottom = "12px";
    storyCard.style.top = "auto";
  }

  animateTitle(CONTENT[currentKey].title);

  const overLayText = CONTENT[currentKey].steps[currentStep] || "";
  typeText(document.getElementById("hs-text"), overLayText, 20);

  storyCard.style.display = "block";
  storyCard.classList.add("active");
}


function applyZoom(img, hs) {
  img.style.transition = "transform 0.5s ease";
  img.style.transform = `scale(${hs.zoom})`;
  img.style.transformOrigin = `${hs.x}% ${hs.y}%`;
}

// ==========================
// AUTOPLAY
// ==========================

function startGuidedMode() {
  clearTimeout(autoTimer);
  clearTimeout(typingTimer);

  isAutoPlaying = true;
  currentIndex = 0;
  currentImageIndex = 0;

  const mergedConfig = Object.assign({}, ...config);

  const hotspotKeys = Object.keys(mergedConfig)
    .filter(key => CONTENT[key]?.steps?.length)
    .sort((a, b) => (HOTSPOT_PRIORITY[a] || 999) - (HOTSPOT_PRIORITY[b] || 999));

  timeline = [];

  hotspotKeys.forEach(key => {
    CONTENT[key].steps.forEach((_, stepIndex) => {
      timeline.push({ key, step: stepIndex });
    });
  });

  if (timeline.length > 0) {
    timeline[timeline.length - 1].isLastStep = true;
  }

  renderState();
}

function renderState() {
  if (!timeline[currentIndex]) return;

  const { key, step, isLastStep } = timeline[currentIndex];

  const targetImageIndex = HOTSPOT_IMAGE_MAP[key] ?? 0;

  if (targetImageIndex !== currentImageIndex) {
    isSwitchingImage = true;

    clearTimeout(autoTimer);

    switchToImage(targetImageIndex);

    setTimeout(() => {
      currentImageIndex = targetImageIndex;
      isSwitchingImage = false;

      renderState();

      if (isAutoPlaying) {
        scheduleNextStep();
      }
    }, 450);

    return;
  }

  const container = containers[currentImageIndex];
  const imageConfig = config[currentImageIndex];

  currentKey = key;
  currentStep = step;
  activeContainer = container;
  activeImageConfig = imageConfig;

  showOnlyHotspotByKey(key);

  clearTimeout(typingTimer);
  typingTimer = null;

  showStep();

  const cta = document.getElementById("cta-block");
  if (isLastStep) cta?.classList.add("show");
  else cta?.classList.remove("show");

  if (isAutoPlaying) {
    scheduleNextStep();
  }
}

function scheduleNextStep() {
  if (!isAutoPlaying) return;

  const basePause = 1200; // 👈 small natural pause
  const totalDelay = (window.currentTypingDuration || 800) + basePause;

  clearTimeout(autoTimer);

  autoTimer = setTimeout(() => {
    if (!isAutoPlaying) return;

    if (currentIndex < timeline.length - 1) {
      currentIndex++;
      renderState();
    }
  }, totalDelay);
}

// ==========================
// HELPERS
// ==========================

function stopAutoPlay() {
  isAutoPlaying = false;
  clearTimeout(autoTimer);
}

function showOnlyHotspotByKey(key) {
  const container = containers[currentImageIndex];
  const imageConfig = config[currentImageIndex];

  const keys = Object.keys(imageConfig);
  const index = keys.indexOf(key);

  const hotspots = container.querySelectorAll(".hotspot");

  hotspots.forEach((h, i) => {
    h.style.opacity = i === index ? "1" : "0";
    h.style.pointerEvents = i === index ? "auto" : "none";
  });
}

function switchToImage(index) {
  document
    .querySelector(`.thumbnail-list__item[data-media-position="${index + 1}"] button`)
    ?.click();
}

function typeText(element, text, speed = 25) {
  if (!text) {
    element.innerText = "";
    return;
  }

  element.innerHTML = "";
  let i = 0;

  clearTimeout(typingTimer);

  function typing() {
    if (i < text.length) {
      element.innerHTML += text[i] === " " ? "&nbsp;" : text[i];
      i++;
      typingTimer = setTimeout(typing, speed);
    }
  }
  typing();
  // ✅ RETURN total typing time
  return text.length * speed;
}

function animateTitle(text) {
  const el = document.getElementById("hs-title");

  el.style.opacity = "0";
  el.style.transform = "translateY(6px)";

  setTimeout(() => {
    el.innerText = text;
    el.style.opacity = "1";
    el.style.transform = "translateY(0)";
  }, 150);
}

// ==========================
// EVENTS
// ==========================

document.getElementById("next").onclick = () => {
  stopAutoPlay();
  clearTimeout(typingTimer);

  if (currentIndex < timeline.length - 1) {
    currentIndex++;
    renderState();
  }
};

document.getElementById("prev").onclick = () => {
  stopAutoPlay();
  clearTimeout(typingTimer);

  if (currentIndex > 0) {
    currentIndex--;
    renderState();
  }
};


document.getElementById("close").onclick = () => {
  isUserInteracted = true; // 🔥 prevent auto restart
  closeHotspotExperience();
};



const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    isInViewport = entry.isIntersecting;
     setTimeout(() => {
    showOverlayTemporarily();
  }, 2000); // slightly after overlay hides

    if (isInViewport && !hasAutoPlayed) {

      // 🔥 Wait before starting (user might scroll away)
      setTimeout(() => {
    // 🔥 DOUBLE GUARD
    if (isUserInteracted) return;
        // ✅ FINAL GUARD CHECK
        if (
          isInViewport &&       // still visible
          !isScrolling &&       // user stopped scrolling
          !hasAutoPlayed &&
          !sessionStorage.getItem(AUTO_PLAY_KEY) && 
           !isUserInteracted
        ) {
          sessionStorage.setItem(AUTO_PLAY_KEY, "true");
          hasAutoPlayed = true;

          //showOverlayTemporarily();

          setTimeout(() => {
             // 🔥 FINAL GUARD (this is missing in your code)
            if (isUserInteracted || isAutoPlaying) {
              return;
            }
            startGuidedMode();
          }, 2500);
        }

      }, 3000); // 👈 your "wait before auto"
    }
  });
}, { threshold: 0.6 });

observer.observe(document.querySelector(".product-media-container"));

// ==========================
// OVERLAY CLICK → START GUIDED MODE
// ==========================

const hsHintOverlay = document.getElementById("hs-hint");

if (hsHintOverlay) {

  hsHintOverlay.addEventListener("click", (e) => {
    e.stopPropagation();

    if (isAutoPlaying) return;

  // 🔥 mark manual interaction
  isUserInteracted = true;

    startGuidedMode();
  });
}

function showOverlayTemporarily() {
  const hsHintOverlay = document.getElementById("hs-hint");
  if (!hsHintOverlay) return;

  hsHintOverlay.style.display = "block";
  hsHintOverlay.style.opacity = "1";
}


setTimeout(() => {
  hasAutoPlayed = false;
}, 120000);


let lastScrollY = window.scrollY;

window.addEventListener("scroll", () => {
  isScrolling = true;

  const currentScrollY = window.scrollY;
  const scrollDiff = Math.abs(currentScrollY - lastScrollY);

  // 🔥 CLOSE only if user actually scrolls AND autoplay is running
  if (isAutoPlaying && scrollDiff > 15) {
    closeHotspotExperience();
  }

  lastScrollY = currentScrollY;

  clearTimeout(scrollTimeout);

  scrollTimeout = setTimeout(() => {
    isScrolling = false;
  }, 150);
});


function closeHotspotExperience() {
  stopAutoPlay();
  clearTimeout(typingTimer);

  // 🔥 reset zoom
  resetZoom();

  // 🔥 hide hotspots
  document.querySelectorAll(".hotspot").forEach(h => {
    h.style.opacity = "0";
    h.style.pointerEvents = "none";
  });

  // 🔥 hide story card
  const storyCard = document.getElementById("story-card");
  storyCard.classList.remove("active");
  storyCard.style.display = "none";

  // 🔥 hide CTA
  const cta = document.getElementById("cta-block");
  cta?.classList.remove("show");
}

document.getElementById("cta-buy").onclick = () => {
  stopAutoPlay(); // keep your existing logic

  // 🔥 Try direct checkout (Buy Now)
  const buyNowBtn = document.querySelector(
    '.shopify-payment-button__button'
  );

  if (buyNowBtn) {
    buyNowBtn.click(); // 🚀 goes to checkout directly
     // show loading state
     const ctaBuyNow = document.querySelector('#cta-buy');
    ctaBuyNow.innerText = "Secure checkout...";
    ctaBuyNow.classList.add('btn-loading');
    return;
  }

  // 🔁 Fallback: Add to cart → then redirect
  const addToCartBtn = document.querySelector('form[action*="/cart/add"] button[type="submit"]');

  if (addToCartBtn) {
    addToCartBtn.click();

    // small delay → then redirect
    setTimeout(() => {
      window.location.href = "/checkout";
    }, 500);
  } else {
    console.warn("No checkout or add-to-cart button found");
  }
};


function resetZoom() {
  document.querySelectorAll(".product-media-container img").forEach(img => {
    img.style.transform = "scale(1)";
    img.style.transformOrigin = "center center";
  });
}



})();